<div class="flxClmn">
    <div class="page-title-container flxClmn-center">
        <div class="page-title-inner-container">
            <span class="page-title">Usage</span>
        </div>
        <div class="page-subtitle-container">
            <span class="page-subtitle">Inbound and outbound license usage</span>
        </div>
    </div>

    <div class="page-inner-content-holder bs-enabled flxClmn vSpace2">
        <div class="f-1-0">
            <!--Licenses Information-->
            <div class="bs-row mb-4">
                <div class="bs-col-12">
                    <div class="trends-data-card flex-column gap-1 p-3 w-100" style="height: clamp(400px,480px,70vh);">
                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Licenses Information</h6>
                            </div>
                        </div>
                        <div class="flex-column f-1-0 p-3 overflow-auto">
                            <trustifi-table-c
                                    class="trustifi-table f-1-0 short-action-column" style="z-index: 5;"
                                    [list]="usage?.general"
                                    [headers]="[
										{text:'Plan', sortKey: 'email', width: '17%'},
										{text:'Expiration', sortKey: 'expired', width: '115px'},
										{text:'Inbound Licenses', sortKey: 'inbound.allowed_users'},
										{text:'Outbound Licenses', sortKey: 'outbound.allowed_users'},
										{text:'Archive'},
										{text:'Threat Simulation'},
										{text:'Account Manager', sortKey: 'account_manager'},
										{text:'Plan Type', sortKey: 'plan_sub_type', width: '9%'},
										{text:'Plan Usage', tooltip: 'Usage data shows the total statistics of data retained in the system for this plan. Data is calculated once a week', width: 'clamp(155px, 12vw, 175px)'}
									]"
                                    [cellsPrototype]="[
                                      {html: 'emailCell'},
                                      {html:'expiredCell'},
                                      {html:'inboundLicenseCell'},
                                      {html:'outboundLicenseCell'},
									  {html:'archiveCell'},
                                      {html:'threatSimulationCell'},
                                      {textKey: 'account_manager'},
                                      {textKey: 'plan_sub_type_display'},
                                      {html:'planUsageCell', overflowOutside: true},
                                    ]"
									[cellActions] = "{
										enable: true,
										selectItemActionCb:	selectPartnerAction,
										initActionsFunction: showPartnerActions
									}"
									(searchFunction)="searchLicenseExpiration($event)"
                                    [options]="{
                                        itemsNameSingular: 'plan',
                                        refreshFunction: getPartnerUsage,
                                        loadingTableFlag: getUsageDataInProcess,
                                        defaultSortKey: 'expired',
                                        exportToCsvFunction: exportLicensesToCsv.bind(this),
                                    }"
                            >
								<ng-template #customCells let-item let-cellId="cellId">
									<!--email cell-->
									<div *ngIf="cellId === 'emailCell'" class="flex-column">
										<span>{{item.email}}</span>
										<span *ngIf="item.company_name">({{item.company_name}})</span>
                                    </div>
									<!--expired cell-->
									<span *ngIf="cellId === 'expiredCell'" [ngStyle]="{'color' : item.planExpired ? 'red' : item.aboutToExpire ? 'darkorange' : ''}">
                                        {{item.expired | date:'MM/dd/yyyy'}}
                                    </span>
									<!--inbound license cell-->
									<div *ngIf="cellId === 'inboundLicenseCell'" class="flxClmn vSpace05">
										<span style="display: block;" [ngStyle]="(item.inbound.used_users > item.inbound.allowed_users) && {'color' : 'red'}">Active: {{item.inbound.used_users}}</span>
										<span *ngIf="item.plan_sub_type !== 'NFR'" style="display: block;">Allocated: {{item.inbound.allowed_users}}</span>
									</div>
									<!--outbound license cell-->
									<div *ngIf="cellId === 'outboundLicenseCell'" class="flxClmn vSpace05">
										<span style="display: block;" [ngStyle]="(item.outbound.used_users > item.outbound.allowed_users) && {'color' : 'red'}">Active: {{item.outbound.used_users}}</span>
										<span *ngIf="item.plan_sub_type !== 'NFR'" style="display: block;">Allocated: {{item.outbound.allowed_users}}</span>
									</div>
									<span *ngIf="cellId === 'archiveCell'"
										  [ngStyle]="item.archive?.wa_enabled ? {} : {'color':'red'}">
										{{item.archive?.wa_enabled ? 'Active: ' + item.archive?.used_users : 'Disabled'}}
									</span>
									<span *ngIf="cellId === 'threatSimulationCell'"
										  [ngStyle]="item.threat_simulation?.enabled ? {} : {'color':'red'}">
										{{item.threat_simulation?.enabled ? 'Active: ' + item.threat_simulation?.used_users : 'Disabled'}}
									</span>
									<!--plan usage cell-->
									<div *ngIf="cellId === 'planUsageCell'" class="flxClmn vSpace05" style="font-size: clamp(9px,0.75vw,13px);">
										<div class="flex-row align-items-center gap-1">
											<div class="rounded-1 flex-shrink-0" style="background: #cb3e00; height: 12px; width: 12px;"></div>
											<div class="flex-row align-items-center f-1-0 gap-1">
												<span>Sent Emails:</span>
												<span>{{item.usage?.emails || 0}}</span>
											</div>
										</div>
										<div class="flex-row align-items-center gap-1">
											<div class="rounded-1 flex-shrink-0" style="background: #34383f; height: 12px; width: 12px;"></div>
											<div class="flex-row align-items-center f-1-0 gap-1">
												<span>Sent Attachments:</span>
												<span>{{item.usage?.attachments || 0}}</span>
											</div>
										</div>
										<div class="flex-row align-items-center gap-1">
											<div class="rounded-1 flex-shrink-0" style="background: #8300ec; height: 12px; width: 12px;"></div>
											<div class="flex-row align-items-center f-1-0 gap-1">
												<span>Inbound Quarantine:</span>
												<span>{{item.usage?.quarantines || 0}}</span>
											</div>
										</div>
										<div class="flex-row align-items-center gap-1">
											<div class="rounded-1 flex-shrink-0" style="background: #e0af00; height: 12px; width: 12px;"></div>
											<div class="flex-row align-items-center f-1-0 gap-1">
												<span>Archived Emails:</span>
												<span>{{item.usage?.archive || 0}}</span>
											</div>
										</div>

										<div class="flex-column my-2 justify-content-center position-relative">
											<apx-chart class="animated fadeIn partner-storage-usage-chart w-100" style="max-height: 25px;"
													   [options]="{display: false}"
													   *ngIf="item.storageUsageBarOptions"
													   [series]="item.storageUsageBarOptions.series"
													   [chart]="item.storageUsageBarOptions.chart"
													   [plotOptions]="item.storageUsageBarOptions.plotOptions"
													   [colors]="item.storageUsageBarOptions.colors"
													   [grid]="item.storageUsageBarOptions.grid"
													   [fill]="item.storageUsageBarOptions.fill"
													   [xaxis]="item.storageUsageBarOptions.xaxis"
													   [yaxis]="item.storageUsageBarOptions.yaxis"
													   [legend]="item.storageUsageBarOptions.legend"
													   [tooltip]="item.storageUsageBarOptions.tooltip"
													   [dataLabels]="item.storageUsageBarOptions.dataLabels"></apx-chart>
											<span [ngStyle]="{'color' : item.totalStorageUsage > item.maxStorageCapacity ? 'var(--bs-danger)' : '#939393'}">
												{{(item.totalStorageUsage) | FormatBytes:0}} / {{(item.maxStorageCapacity) | FormatBytes:0}}
											</span>
										</div>
									</div>
								</ng-template>
								<div tableButtons>
									<btn-c endIcon="fas fa-chart-pie" variant="outlined"
										   (action)="showGenerateReportPopup();">
										Generate Report
									</btn-c>
								</div>
                            </trustifi-table-c>
                        </div>
                    </div>
                </div>
            </div>

            <!--inbound-->
            <div class="bs-row border-between g-4">
                <!--Inbound Licenses-->
                <div class="bs-col-6 flex-column gap-4">
                    <div class="trends-data-card flex-column p-3 w-100" style="height: clamp(450px,55vh,508px);">
                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Inbound Licenses</h6>
                            </div>
                            <span class="opacity-75 fw-500 text-start" style="height: 32px;">Shows the amount of inbound licenses (mailboxes) that are currently active (used) out of your total</span>
                        </div>
                        <div class="flex-column gap-3 f-1-0 animated fadeIn" *ngIf="usage">
                            <div class="flex-row px-2 py-4 justify-content-between align-items-center">
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 180px;">
                                    <h4 class="m-0 fw-bold text-success">{{usage.inbound.used_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Active licenses</span>
                                </div>
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 180px;">
                                    <h4 class="m-0 fw-bold">{{usage.inbound.allowed_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Allocated licenses</span>
                                </div>
                                <div class="flex-row f-1-0" style="max-width: 40%; max-height: 15vh;">
                                    <apx-chart style="max-width: 220px; width: 100%;"
											   [series]="inboundUsersMeterChartOptions.series"
											   [plotOptions]="inboundUsersMeterChartOptions.plotOptions"
											   [chart]="inboundUsersMeterChartOptions.chart"
											   [colors]="inboundUsersMeterChartOptions.colors"
											   [labels]="inboundUsersMeterChartOptions.labels">
									</apx-chart>
                                </div>
                            </div>
                            <hr class="w-100 mt-0">
                            <div class="flex-row w-100 justify-content-center f-1-0">
                                <div class="flex-row text-center f-1-0 justify-content-center gap-1 p-4" style="max-width: 45%;">
                                    <span class="fw-500">Inbound Plan Type Distribution</span>
                                    <i style="font-weight: 400;" class="far fa-question-circle" title="Shows the distribution of plan types (Annual/Monthly/PoC/NFR/PRO) between your active inbound licenses"></i>
                                </div>
                                <div class="flex-column centralize f-1-0" [ngClass]="{'border' : usage.inbound.used_users < 1}">
                                    <apx-chart class="pie-chart f-1-0" style="width: 100%; max-width: min(38vh,340px);"
											   *ngIf="usage.inbound.used_users > 0"
											   [series]="inboundPlansTypesChartOptions.series"
											   [dataLabels]="inboundPlansTypesChartOptions.dataLabels"
											   [plotOptions]="inboundPlansTypesChartOptions.plotOptions"
											   [chart]="inboundPlansTypesChartOptions.chart"
											   [colors]="inboundPlansTypesChartOptions.colors"
											   [labels]="inboundPlansTypesChartOptions.labels">
									</apx-chart>
                                    <span class="text-dark" *ngIf="usage.inbound.used_users < 1">No active licenses</span>
                                </div>
                            </div>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 centralize animated fadeIn h-100 w-100" *ngIf="getUsageDataInProcess">
                            <loader class="opacity-75" height="100" width="100"></loader>
                        </div>
                    </div>


                    <!--Top Inbound Plan Usage-->
                    <div class="trends-data-card gap-2 flex-column p-3 w-100" style="height: clamp(450px,55vh,508px);">
                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Top Inbound Plan Usage</h6>
                            </div>
                            <span class="opacity-75 fw-500 text-start">Shows the plans (by admin) which use the most inbound licenses.</span>
                        </div>
                        <div class="flex-column centralize f-1-0 animated fadeIn"
                             *ngIf="usage"
                             [ngClass]="{'border' : usage.inbound.used_users < 1}">
                            <span class="text-dark" *ngIf="usage.inbound.used_users < 1">No active licenses</span>
                            <apx-chart class="f-1-0 w-100" *ngIf="usage.inbound.used_users > 0"
									   [series]="inboundTopPlanUsageChartOptions.series"
									   [dataLabels]="inboundTopPlanUsageChartOptions.dataLabels"
									   [plotOptions]="inboundTopPlanUsageChartOptions.plotOptions"
									   [chart]="inboundTopPlanUsageChartOptions.chart"
									   [colors]="inboundTopPlanUsageChartOptions.colors"
									   [xaxis]="inboundTopPlanUsageChartOptions.xaxis">
                            </apx-chart>
                        </div>


                        <!--loader / placeholder-->
                        <div class="flex-column p-3 centralize animated fadeIn h-100 w-100" *ngIf="getUsageDataInProcess">
                            <loader class="opacity-75" height="100" width="100"></loader>
                        </div>
                    </div>
                </div>

                <!--outbound-->
                <!--Outbound Licenses-->
                <div class="bs-col-6 flex-column gap-4">
                    <div class="trends-data-card flex-column p-3 w-100" style="height: clamp(450px,55vh,508px);">
                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Outbound Licenses</h6>
                            </div>
                            <span class="opacity-75 fw-500 text-start" style="height: 32px;">Shows the amount of outbound licenses (users) that are currently active (used) out of your total</span>
                        </div>
                        <div class="flex-column gap-3 f-1-0 animated fadeIn" *ngIf="usage">
                            <div class="flex-row px-2 py-4 justify-content-between align-items-center">
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 180px;">
                                    <h4 class="m-0 fw-bold text-success">{{usage.outbound.used_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Active licenses</span>
                                </div>
                                <div class="flex-column align-items-start gap-1" style="flex-basis: 180px;">
                                    <h4 class="m-0 fw-bold">{{usage.outbound.allowed_users || '0'}}</h4>
                                    <span class="opacity-75 fw-500 text-start">Allocated licenses</span>
                                </div>
                                <div class="flex-row f-1-0" style="max-width: 40%; max-height: 15vh;">
                                    <apx-chart style="max-width: 220px; width: 100%;"
											   [series]="outboundUsersMeterChartOptions.series"
											   [plotOptions]="outboundUsersMeterChartOptions.plotOptions"
											   [chart]="outboundUsersMeterChartOptions.chart"
											   [colors]="outboundUsersMeterChartOptions.colors"
											   [labels]="outboundUsersMeterChartOptions.labels">
									</apx-chart>
                                </div>
                            </div>
                            <hr class="w-100 mt-0">
                            <div class="flex-row w-100 justify-content-center f-1-0">
                                <div class="flex-row text-center f-1-0 justify-content-center gap-1 p-4" style="max-width: 45%;">
                                    <span class="fw-500">Outbound Plan Type Distribution</span>
                                    <i style="font-weight: 400;" class="far fa-question-circle" title="Shows the distribution of plan types (Annual/Monthly/PoC/NFR/PRO) between your active outbound licenses"></i>
                                </div>
                                <div class="flex-column centralize f-1-0" [ngClass]="{'border' : usage.outbound.used_users < 1}">
                                    <apx-chart class="pie-chart f-1-0" style="width: 100%; max-width: min(38vh,340px);"
											   *ngIf="usage.outbound.used_users > 0"
											   [series]="outboundPlansTypesChartOptions.series"
											   [plotOptions]="outboundPlansTypesChartOptions.plotOptions"
											   [chart]="outboundPlansTypesChartOptions.chart"
											   [dataLabels]="outboundPlansTypesChartOptions.dataLabels"
											   [colors]="outboundPlansTypesChartOptions.colors"
											   [labels]="outboundPlansTypesChartOptions.labels">
									</apx-chart>
                                    <span class="text-dark" *ngIf="usage.outbound.used_users < 1">No active licenses</span>
                                </div>
                            </div>
                        </div>
                        <!--loader / placeholder-->
                        <div class="flex-column p-3 centralize animated fadeIn h-100 w-100" *ngIf="getUsageDataInProcess">
                            <loader class="opacity-75" height="100" width="100"></loader>
                        </div>
                    </div>

                    <!--Top Outbound Plan Usage-->
                    <div class="trends-data-card gap-2 flex-column p-3 w-100" style="height: clamp(450px,55vh,508px);">
                        <div class="flex-column align-items-start gap-1">
                            <div class="flex-row align-items-center gap-1">
                                <h6 class="m-0 fw-bold">Top Outbound Plan Usage</h6>
                            </div>
                            <span class="opacity-75 fw-500 text-start">Shows the plans (by admin) which use the most outbound licenses.</span>
                        </div>
                        <div class="flex-column centralize f-1-0 animated fadeIn"
                             *ngIf="usage"
                             [ngClass]="{'border' : usage.outbound.used_users < 1}">
                            <span class="text-dark" *ngIf="usage.outbound.used_users < 1">No active licenses</span>
                            <apx-chart class="f-1-0 w-100" *ngIf="usage.outbound.used_users > 0"
									   [series]="outboundTopPlanUsageChartOptions.series"
									   [plotOptions]="outboundTopPlanUsageChartOptions.plotOptions"
									   [chart]="outboundTopPlanUsageChartOptions.chart"
									   [dataLabels]="outboundTopPlanUsageChartOptions.dataLabels"
									   [colors]="outboundTopPlanUsageChartOptions.colors"
									   [xaxis]="outboundTopPlanUsageChartOptions.xaxis">
                            </apx-chart>
                        </div>

                        <!--loader / placeholder-->
                        <div class="flex-column p-3 centralize animated fadeIn h-100 w-100" *ngIf="getUsageDataInProcess">
                            <loader class="opacity-75" height="100" width="100"></loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--Partners Report popup-->
    <popup-c class="bs-enabled" *ngIf="generateReportPopup?.show"
           head="Partners Report"
           subTitle="Scheduled reports of your usage of inbound and outbound licenses"
           (closeCb)="generateReportPopup = null"
           size="medium" width="850px">
        <div class="flex-column gap-5 f-1-0" style="overflow: auto;">
			<div class="f-1-0 d-flex centralize" *ngIf="generateReportPopup.getPartnerInfoInProcess">
				<loader height="100" width="100" style="opacity: 0.8;"></loader>
			</div>
			<ng-container *ngIf="!generateReportPopup.getPartnerInfoInProcess && partnerInfo">

				<div class="flex-row">
					<div class="flex-column gap-2" style="flex-basis: 300px; flex-shrink: 0;">
						<span style="font-weight: bold;">Schedule report</span>
						<span class="lh-base" style="font-size: 0.9em;">Scheduled automatic reports that will be sent to reviewers on a daily, weekly, or monthly basis.</span>
					</div>
					<div class="flex-column gap-2 w-100">
						<div *ngFor="let period of ['daily','weekly','monthly']" class="flxRow-start w100 gap-2" style="align-items: center;">
							<div class="flxRow gap-2" style="white-space: nowrap; align-items: center; flex-basis: 165px; flex-shrink: 0;">
								<toggle-switch-c id="{{period}}ReportToggle"
												 [hideText]="true"
												 [(model)]="partnerInfo.partners.scheduled_reports[period].value"
												 (onChange)="updateReportSettings()"></toggle-switch-c>
								<span style="vertical-align: middle; text-transform: capitalize;">{{period}} report</span>
							</div>
							<div class="flxRow" style="flex-direction: column;">
								<span [ngClass]="{'text-success' : partnerInfo.partners.scheduled_reports[period]?.value}">Report will be sent {{period === 'daily' ? 'each day' : period === 'weekly' ? 'each Monday' : period === "monthly" ? 'on the 1st of each month' : ''}}.</span>
								<span *ngIf="partnerInfo.partners.scheduled_reports[period].last_report" style="color: green;">(Last report: {{partnerInfo.partners.scheduled_reports[period].last_report | date:'MM/dd/yyyy HH:mm'}})</span>
							</div>
						</div>
					</div>
				</div>

				<div class="flex-row">
					<div class="flex-column gap-2" style="flex-shrink: 0; flex-basis: 300px;">
						<b>Extended report</b>
						<span class="lh-base" style="font-size: 0.9em;">Include a full list of all active users and mailboxes.</span>
					</div>
					<div>
						<toggle-switch-c id="include_active_licenses"
										 [hideText]="true"
										 [(model)]="partnerInfo.partners.scheduled_reports.include_active_licenses"
										 (onChange)="updateReportIncludeActiveLicenses()"></toggle-switch-c>
					</div>
				</div>

				<!--Addresses -->
				<div class="flex-row">
					<div class="flex-column gap-2" style="flex-shrink: 0; flex-basis: 300px;">
						<b>Add report recipients (optional)</b>
						<span class="lh-base" style="font-size: 0.9em;">Add the specific addresses to which you would like the report to be sent, in addition to reviewers.</span>
					</div>
					<div class="content-container flex-column gap-2">
						<div class="flex-row gap-1">
							<input type="text" style="width: 300px; margin: 0;"
								   placeholder="Add"
								   (keyup.enter)="addReportAddress(generateReportPopup.address);"
								   [(ngModel)]="generateReportPopup.address">
							<btn-c style="min-width: 0;"
								   [endIcon]="'zmdi zmdi-check'"
								   [isDisabled]="!generateReportPopup.address"
								   [loading]="generateReportPopup.actionInProcess"
								   (action)="addReportAddress(generateReportPopup.address);">
							</btn-c>
						</div>
						<div *ngFor="let address of partnerInfo.partners.scheduled_reports.report_to_emails; trackBy: gs.trackByIndex" style="margin-bottom: 10px;">
							<div class="name ellipsis"
								 style="display: inline-block; width: 310px;">{{address}}</div>
							<a class="closeRed action"
							   (click)="deleteReportAddress(address)"
							   [ngClass]="generateReportPopup.actionInProcess ? 'closeRed disableAction' : 'approveGreen'">
								<i class="far fa-times"></i>
							</a>
						</div>
					</div>
				</div>

				<hr class="m-0"/>
				<!--Download report-->
				<div class="flxRow hSpace1" style="align-items: center;">
					<div class="flex-column gap-2" style="flex-shrink: 0; flex-basis: 300px;">
						<b>Generate report now</b>
						<span class="lh-base" style="font-size: 0.9em;">The system will generate a report of your total used licenses. The report will be sent to your mailbox.</span>
					</div>
					<btn-c [isDisabled]="generateReportPopup.inProcess"
						   (click)="generatePartnersReportNow();">
						Create
					</btn-c>
				</div>

			</ng-container>
        </div>
    </popup-c>
</div>

<!--Modify/Allocate admin plan popup-->
<popup-c class="no-content-padding form" *ngIf="updateAdminPlanPopup && isPartnerAdmin"
		 [head]="'Modify Admin Plan Resources'"
		 size="large" subTitle="Modify {{curSharedUser.name}}'s plan resources"
		 (closeCb)="closeAllocateModifyPopup();">
	<div class="flxClmn f-1-0 vSpace1" style="padding: 10px 25px 25px 25px;; overflow: auto;">
		<div class="input-wrap flxClmn f-1-0 bs-enabled" style="background: #fcfcfc; overflow: auto; padding: 5px 10px 10px 10px;">
			<div class="flex-column vSpace2">
				<div class="flex-column gap-2">
					<div class="flex-row align-items-center gap-2">
						<span class="d-flex justify-content-end" style="flex-basis: 106px;">Plan Type:</span>
						<app-dropdown-c style="width: 230px; display: inline-flex;" text="{{dic.CONSTANTS.planSubTypeMap[curSharedUser.planSubType]}}">
							<li *ngFor="let type of dic.CONSTANTS.planSubType | keyvalue: gs.returnZero"
								(click)="changePlanSubType(type.value)">
								{{dic.CONSTANTS.planSubTypeMap[type.key]}}
							</li>
						</app-dropdown-c>
						<i style="font-weight: 400;" *ngIf="curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp" class="far fa-question-circle" tooltip="<b>Monthly</b> - The plan's expiration and allowed emails will refresh on a monthly basis, on the 1st of each month."></i>
					</div>
					<div class="flex-column gap-2">
						<div class="flex-row align-items-center gap-2">
							<span class="d-flex justify-content-end" style="flex-basis: 106px;">Expires on:</span>
							<label style="margin-bottom: 0; display: contents;"
								   *ngIf="curSharedUser.planSubType === dic.CONSTANTS.planSubType.annual"
								   [ngStyle]="curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp && {'pointer-events': 'none'}">
								<div class="plan-expiration-extend-menu" style="position: relative; width: 230px; display: inline-block; cursor: unset;">
									<input type="text" style="margin: 0; width: 100%;"
										   [value]="curSharedUser.newExpirationDate && curSharedUser.planSubType === dic.CONSTANTS.planSubType.annual ? (curSharedUser.newExpirationDate | date: 'MM/dd/yyyy') : (curSharedUser.adminExpirationDate | date: 'MM/dd/yyyy')"
										   [readOnly]="true"
										   [ngClass]="{'text-success fw-bold' : curSharedUser.extendExpirationMethod}"
										   [ngStyle]="{'background-color' : curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp ? '#ecf0f1' : ''}"
										   readonly />
									<a class="blue-link" style="position: absolute; top: 50%; transform: translateY(-50%); right: 10px; font-size: 12px;"
									   (click)="curSharedUser.isExtendExpirationMenuOpen = !curSharedUser.isExtendExpirationMenuOpen; $event.preventDefault();"
									   (clickOutside)="curSharedUser.isExtendExpirationMenuOpen = false;"
									   [exclude]="'#extendExpirationMenu'">
										Extend
									</a>
									<div class="drop-menu" style="padding: 0; min-width: 0; min-height: 0; max-width: none; max-height: none; width: 165px; height: auto; box-shadow: 1px 0 3px #cccccc; border-radius: 5px; border: solid 1px lightgrey; left: auto; top: 0; bottom: auto; right: -3px;"
										 [ngClass]="{'active' : curSharedUser.isExtendExpirationMenuOpen}"
										 id="extendExpirationMenu">
										<ul>
											<li *ngFor="let period of expandMethods | keyvalue: gs.returnZero"
												[hidden]="period.key === 'twoYears' || period.key === 'threeYears'"
												(click)="updateExpirationTime(period.value.value); prepareInvoiceNotifyMessage();">
												<div class="flxRow hSpace05" style="align-items: center;"
													 [ngStyle]="{'font-weight' : curSharedUser.extendExpirationMethod === period.value.value ? 'bold' : 'normal'}">
													<i class="far fa-plus"></i>
													<span>Add {{period.value.display}}</span>
												</div>
											</li>
										</ul>
									</div>
									<a class="closeRed" style="position: absolute; top: 50%; transform: translateY(-50%); right: -25px; padding: 5px; opacity: 0.5;"
									   tooltip="Cancel extending"
									   *ngIf="curSharedUser.extendExpirationMethod && updateAdminPlanPopup"
									   (click)="cancelExtendExpirationDate()">
										<i class="far fa-times" ></i>
									</a>
								</div>
							</label>

							<input type="text" style="margin: 0; width: 230px;" readonly
								   *ngIf="curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp"
								   [value]="curSharedUser.adminExpirationDate | date: 'MM/dd/yyyy'" />
							<date-picker-c
								*ngIf="curSharedUser.planSubType !== dic.CONSTANTS.planSubType.annual && curSharedUser.planSubType !== dic.CONSTANTS.planSubType.msp"
								[(dateModel)]="curSharedUser.adminExpirationDate"
								[dateMinLimit]="curSharedUser.showOldExpirationDate ? curSharedUser.adminExpirationDateString : adminExpirationDateMinString"
								[dateMaxLimit]="adminExpirationDateMaxString"
								[allowFuture]="true" style="width: 230px; display: inline-block;"></date-picker-c>

							<span style="color: #818181;" *ngIf="curSharedUser.planSubType === dic.CONSTANTS.planSubType.msp">Automatically renewed monthly</span>
						</div>
						<div class="flex-row align-items-center gap-2">
							<span class="d-flex justify-content-end" style="flex-basis: 106px;">Company Name:</span>
							<input type="text"
								   style="width:230px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
								   maxlength="100"
								   placeholder="Company Name (optional)"
								   [(ngModel)]="curSharedUser.companyName" />
						</div>
						<div class="flex-row align-items-center gap-2">
							<checkbox id="setAsPartnerId2" [(model)]="curSharedUser.setAsPartner" style="flex-basis: 106px;">
								Set as Partner
							</checkbox>
							<input type="text"
								   [disabled]="!curSharedUser.setAsPartner"
								   style="width:230px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
								   maxlength="100"
								   placeholder="Partner ID"
								   [(ngModel)]="curSharedUser.customerId"
								   pattern="/^[a-zA-Z]*$/"/>
						</div>
						<span>Allocating a Partner-ID will allow this admin to create and allocate plans. Can contain letters only</span>
						<ng-container>
							<div class="flxRow hSpace2 mt-3 mb-3" style="align-items: center;">
								<checkbox [(model)]="curSharedUser.archive.wa_enabled"
										  *ngIf="currentAdminObj.archive">
									Enable <b>Archive</b>
								</checkbox>
								<checkbox [(model)]="curSharedUser.threat_simulation.enabled"
										  *ngIf="currentAdminObj.threat_simulation">
									Enable <b>Threat Simulation</b>
								</checkbox>
								<checkbox [(model)]="curSharedUser.allow_support_wa">
									Enable <b>Support Tickets</b>
									<i style="font-weight: 400; margin-left: 3px;  position: relative;" class="far fa-question-circle opacity-75"
									   tooltip='Allow users from this plan to create and view support tickets from the Trustifi portal'></i>
								</checkbox>
								<checkbox [(model)]="curSharedUser.hide_partner_access">
									Limited access
									<i style="font-weight: 400; margin-left: 3px;  position: relative;" class="far fa-question-circle opacity-75"
									   tooltip="When enabled, the partner's access to this client is limited to usage statistics only. Direct management access is disabled"></i>
								</checkbox>
							</div>
						</ng-container>

						<div class="flxRow hSpace3" style="margin-top: 10px;">
							<div class="flex-column gap-1" style="flex-shrink: 0; flex-grow: 1;">
								<!--Outbound-->
								<label style="padding-top: 5px; vertical-align: unset; min-width: 100px; font-weight: bold; font-size: 14px; text-decoration: underline; margin-bottom: 10px;">
									Outbound Resources
								</label>
								<div class="flex-row align-items-center gap-2">
									<span style="flex-basis: 70px;">Users:</span>
									<input type="number" min="1"
										   style="width:120px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
										   step="1" placeholder="Num"
										   [(ngModel)]="curSharedUser.allowedUsers"
										   (change)="prepareInvoiceNotifyMessage();">
									<span style="color: #818181;"
									  *ngIf="userManagementLoaded">
										Available: {{currentAdminObj.shared_plan.allowed_users - currentAdminObj.shared_plan.used_users + curSharedUser?.shared_plan?.allowed_users - curSharedUser.allowedUsers}}
									</span>
								</div>
							</div>
							<div class="vertical-separator" style="height: auto; border-left: none; opacity: 0.5;"></div>

							<div class="flex-column gap-1" style="flex-shrink: 0; flex-grow: 1;">
								<label style="padding-top: 5px; vertical-align: unset; min-width: 100px; font-weight: bold; font-size: 14px; text-decoration: underline; margin-bottom: 10px;">Inbound Resources</label>

								<div class="flex-row align-items-center gap-2">
									<span style="flex-basis: 70px;">Mailboxes:</span>
									<input type="number" min="0"
										   style="width: 120px; border-radius: 4px; box-sizing: border-box; border: 1px solid #ccc; padding: 2px 8px;"
										   step="1" placeholder="Num"
										   [(ngModel)]="curSharedUser.allowedLicenses"
										   (change)="prepareInvoiceNotifyMessage();">
									<span style="color: #818181;"
									  *ngIf="userManagementLoaded">
											Available: {{currentAdminObj.threat_protection.allowed_users - currentAdminObj.threat_protection.used_users + curSharedUser?.threat_protection?.allowed_users - curSharedUser.allowedLicenses}}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="flxRow-between hSpace4 bs-enabled" style="align-items: flex-end; margin-top: 15px; min-height: 85px;">
			<div class="flxClmn vSpace1">
				<div class="text-danger" *ngIf="curSharedUser.errMsg">{{curSharedUser.errMsg}}</div>
				<div class="flex-row align-items-center bg-warning border border-warning gap-3 p-2 animated fadeIn" style="--bs-bg-opacity: .15;"
					 *ngIf="curSharedUser.invoiceNotify">
					<i class="far fa-exclamation-circle text-warning" style="font-size: 1rem;"></i>
					<div class="flex-column">
						<div class="flex-row gap-1 align-items-center">
							<i class="fa fa-circle" style="font-size:0.3em;"></i>
							<span [innerHTML]="curSharedUser.invoiceNotify"></span>
						</div>
						<div class="flex-row gap-1 align-items-center">
							<i class="fa fa-circle" style="font-size:0.3em;"></i>
							<span>Action will take place only after clicking "Update"</span>
						</div>
					</div>
				</div>
			</div>
			<div class="flxRow hSpace1">
				<btn-c class="popup-action-btn" variant="outlined"
					   [loading]="setUserAsAdminInProcess"
					   (action)="closeAllocateModifyPopup();">
					Cancel
				</btn-c>
				<button type="submit" style="display: contents;" [disabled]="isUpdateDisabled()">
					<btn-c class="popup-action-btn"
						   [loading]="setUserAsAdminInProcess"
						   [isDisabled]="isUpdateDisabled()"
						   (action)="updateAdminPlanExecute()">
						Update
					</btn-c>
				</button>
			</div>
		</div>
	</div>
</popup-c>

